import React from 'react'
import { useNavigate } from 'react-router-dom'

const TabCalender = ({ tabs, setTabName, tabName }) => {
  const navigate = useNavigate();
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  return (
    <div className='w-auto max-sm:w-full'>
      <div className="border-b border-gray-200">
        <div>
          <nav className="-mb-px flex sm:space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <div
                key={tab.name}
                onClick={() => {
                  setTabName(tab.name)
                  navigate(tab.href);
                }}
                className={classNames(
                  tab.current === true  
                    ? 'border-[var(--brand-primary)] text-gray-900'
                    : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-700',
                  'whitespace-nowrap max-sm:w-1/2 border-b-2 pb-3 py-2 text-center px-1 text-base font-medium cursor-pointer'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                {tab.name}
              </div>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}

export default TabCalender;